import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-rangebox',
  imports: [FormsModule],
  templateUrl: './rangebox.html',
  styles: ``,
})
export class Rangebox {
  @Input() label: string = '';
  @Input() value: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 100;
}
